import React, { useEffect, useRef } from "react";
import module from "./Teams.module.css";
import { Box, Checkbox, FormControlLabel } from "@mui/material";

const paddingNum = 32;

const Teams = ({ setIsRead, isRead }) => {
  const handleChange = () => {
    setIsRead((prev) => !prev);
  };
  return (
    <div className={module.container}>
      <span className={module.useLabel}>利用規約</span>{" "}
      <span className={module.useLabel}>{"(最後までお読みください)"}</span>
      <Box
        sx={{
          height: "160px",
          overflowY: "scroll",
          border: "1px black solid",
          borderRadius: "5px",
          padding: "16px 8px",
          fontSize: "0.8rem",
        }}
        id={"terms"}
      >
        <div>
          <span>
            ナッシュ株式会社（以下「当社」といいます。）が、利用者に対して提供するnoshサービスの利用について、以下のとおり本利用規約を定めます。
          </span>
        </div>
        <div>
          <span>
            本サービスの利用者（以下「利用者」といいます。）は、あらかじめ本利用規約に同意した上で、ウェブサイト、電話、FAXを通じて当サービスを利用するものとします。
          </span>
        </div>
        <ul className={module.ul}>
          <li>第1条（総則）</li>
          <ol>
            <li>
              本規約は、ナッシュ株式会社（以下「当社」といいます。）が提供する「ナッシュアンバサダープログラム」（以下「本プログラム」といいます。）に参加するアンバサダーが、本プログラムへの参加及び利用に関して遵守すべき事項を定めるものです。
            </li>
            <li>
              アンバサダーは、当社所定の方法により本規約に同意した上で本プログラムを利用するものとし、本規約に同意いただけない場合は本プログラムの利用はできません。
            </li>
          </ol>
          <li>第2条（定義）</li>
          <span>
            本規約における用語の定義は、本規約中に別段の定めがある場合を除き、次の各号に従うものとします。
          </span>
          <ol className={module.child}>
            <li>
              「本プログラム」とは、本規約が定める方法・条件に基づき、アンバサダーがアフィリエイト媒体に専用ページへのリンク等を設置し、当該専用ページを経由してユーザが本商品を購入した場合に、当社がアンバサダーに対して本報酬を付与するサービスをいいます。
            </li>
            <li>
              「本商品」とは、当社が取扱う冷凍宅配弁当等の定期購入サービスをいいます。
            </li>
            <li>
              「アンバサダー」とは、本プログラムを利用して本商品を第三者に紹介する者をいいます。
            </li>
            <li>
              「ユーザ」とは、本プログラムによりアンバサダーから商品の紹介を受けた者で、本商品の新規利用者をいいます。
            </li>
            <li>
              「本報酬」とは、本プログラムに基づき、当社からアンバサダーに提供される成果報酬その他の報酬をいいます。
            </li>
            <li>
              「専用ページ」とは、本プログラムに基づく本商品の紹介や購入を目的として、当社がアンバサダーに発行した専用のウェブページをいいます。
            </li>
            <li>
              「アフィリエイト媒体」とは、ウェブサイト、SNS、SMS、電子メールその他の本プログラムの紹介を行う媒体をいいます。
            </li>
            <li>
              「リンク等」とは、アフィリエイト媒体に設置するURLリンク、QRコード※、バナーその他の専用ページへの誘導手段をいいます。
            </li>
            <span>
              ※「QRコード」は、株式会社デンソーウェーブの登録商標です。
            </span>
          </ol>
          <li>第3条（アンバサダーのアカウント登録）</li>
          <ol className={module.outer}>
            <li>
              本プログラムの利用を希望する者（以下「登録希望者」といいます。）は、第1条第2項に基づき本規約に同意した上で、当社所定の本プログラムの利用登録に関する申込手続（以下「アカウント登録申請」といいます。）を完了することで、登録希望者から当社に対する契約申込みの効力が生じるものとします。
            </li>
            <li>
              当社は、前項のアカウント登録申請の可否を当社の基準に基づき判断するものとし、第4条第1項に定める方法による当社の承諾をもって本プログラムの利用契約（以下「本契約」といいます。）が成立し、アカウント登録が完了するものとします。
            </li>
            <li>
              当社は、アカウント登録申請が承認された登録希望者に対し、アンバサダーのアカウント登録後、遅滞なく専用ページを作成し、そのリンク等をアンバサダーに付与するものとします。
            </li>
            <li>
              当社は、登録希望者が次の各号のいずれかに該当すると判断した場合は、利用登録の申請を承認しないことがあります。この場合、当社は、利用登録を承認しない理由について一切開示する義務を負わないものとします。
            </li>
            <ol className={module.inner}>
              <li>
                当社に提供した登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合
              </li>
              <li>本人でない場合 </li>
              <li>未成年者の場合</li>
              <li>
                成年被後見人、被保佐人又は被補助人のいずれかであり、後見人、保佐人又は補助人の同意等を得ていなかった場合
              </li>
              <li>
                反社会的勢力（暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、特殊知能暴力集団その他これらに準ずる者をいいます。）に該当すると認められる場合又は不正・不当な目的のために反社会的勢力を利用したと認められる場合
              </li>
              <li>
                自己又は第三者を利用して、暴力的な要求行為、法的な責任を超えた不当な要求行為、取引に関して脅迫的な言動又は暴力を用いる行為、風説の流布・偽計・威力を用いた信用棄損・業務妨害その他これらに準ずる行為に及んだと認められる場合
              </li>
              <li>
                過去に当社との契約若しくは本規約に違反した者又はその関係者である場合
              </li>
              <li>第5項の資料を当社が指定する期限までに提出しなかった場合</li>
              <li>その他、当社がアカウント登録を適当でないと判断した場合</li>
            </ol>
            <li>
              アンバサダーは、アンバサダー登録の前後を問わず、当社から登録情報の確認のために資料の提出を求められた場合には、当社が指定する期間内にこれを提出するものとします。
            </li>
            <li>
              アンバサダーは、登録内容の変更がある場合は、速やかに登録の変更をしなければならないものとします。
            </li>
            <li>
              前2項に基づく追加登録若しくは登録事項の変更の連絡をアンバサダーが遅滞した場合、又は登録事項の内容に虚偽、誤り若しくは記載漏れがあった場合、これによりアンバサダーに損害が生じたとしても、当社は当該損害を賠償する責任を一切負わないものとします。
            </li>
            <li>
              アンバサダーは、アカウント情報を第三者等に利用させ、譲渡、売買、質入、貸与、賃貸その他の処分をすることはできないものとします。
            </li>
            <li>
              アンバサダーは、自己が登録したメールアドレス、電話番号、パスワード等のアカウント情報を自らの責任において管理するものとします。
            </li>
            <li>
              アンバサダーのアカウント情報の管理不十分による情報の漏洩、使用上の過誤、第三者の使用、不正アクセス等による損害の責任はアンバサダーが負うものとし、当社は一切責任を負わないものとします。また、アカウント情報が不正に利用されたことにより当社に損害が生じた場合、アンバサダーは当該損害を賠償するものとします。
            </li>
          </ol>
          <li>第4条（通知・連絡）</li>
          <ol className={module.outer}>
            <li>
              当社からアンバサダーへの通知は、電子メールの送信、本プログラムサイトへの掲載、電話その他の当社が適当であると判断する方法により行います。なお、電子メールはアンバサダーがあらかじめ登録した電子メールアドレス宛てに送信するものとします。
            </li>
            <li>
              当社がアンバサダーに対して行う通知は、次の時点をもって効力が発生するものとします。
            </li>
            <ol className={module.inner}>
              <li>
                電子メールによる場合：アンバサダーがあらかじめ登録した電子メールアドレスに当社が電子メールを送信した時点
              </li>
              <li>
                本プログラムサイトへの掲載による場合：通知等の内容を本プログラムサイト上に掲載した時点
              </li>
            </ol>
            <li>
              アンバサダーが当社に連絡をする場合は、当社が他の方法を指定する場合を除き、本プログラムサイト上に設置された問合せ専用フォームを利用して行うものとします。
            </li>
          </ol>
          <li>第5条（リンク等の掲示）</li>
          <ol>
            <li>
              アンバサダーは、アフィリエイト媒体にリンク等を設置することができます。ただし、当社がリンク等の設置について方法を指定又は条件を付している場合、これに従うものとします。
            </li>
            <li>
              アンバサダーは、当社から付与されたリンク等を、本規約に基づく本プログラムの利用目的以外で使用することはできません。
            </li>
            <li>
              リンク等が設置されたアフィリエイト媒体に以下の各号のいずれかに該当する内容が含まれると当社が判断した場合、当社は、アンバサダーに対してその内容・表示方法等の変更又は削除を求めることができるものとし、アンバサダーは、これに従うものとします。
            </li>
            <ol>
              <li>
                法律（景品表示法、薬機法、健康増進法、商標法、著作権法、特定商取引法等を含みますがこれらに限られません。）、規則、条例、ガイドライン等に反する、又はそのおそれのある表示
              </li>
              <li>
                本商品の品質、規格その他の内容について、実際の商品又は他社商品よりも著しく優良であると誤認させるような表示
              </li>
              <li>
                本商品の価格その他の取引条件について、実際の商品又は他社商品よりも著しく有利であると誤認させるような表示
              </li>
              <li>
                本商品が医薬的な効能、効果又は性能を有すると誤認させる表示
              </li>
              <li>
                本商品の健康保持増進効果について著しく事実に相違する表示をし、又は著しく人を誤認させるような表示
              </li>
              <li>
                第三者の商標権、著作権その他の知的財産権を侵害する表示（適法に権利者の承諾を得ている場合は除きます。）
              </li>
              <li>
                第三者の肖像権やプライバシー権を侵害する表示（適法に権利者の承諾を得ている場合は除きます。）
              </li>
              <li>犯罪を助長・協力・誘発するなど、犯罪行為に関連する表示</li>
              <li>
                アダルトコンテンツ、差別的表現、残虐な表現その他一般人に不快感を与える表示
              </li>
              <li>
                児童ポルノ又は児童虐待に相当するおそれのある内容及び未成年者に有害と認められる表示
              </li>
              <li>
                社会的非難の原因となる表示（SNS等でいわゆる炎上の原因となるおそれのある表示を含みます。）
              </li>
              <li>公序良俗に反する表示</li>
              <li>当社の代理人であると誤認されるような表示</li>
              <li>本規約に違反する表示</li>
              <li>その他当社が不適切であると判断する表示</li>
            </ol>
          </ol>
          <li>第6条（本報酬の付与）</li>
          <ol>
            <li>
              ユーザが専用ページを経由して購入した本商品の配送が正常に完了し、かつ、アンバサダーの銀行口座登録が正常に完了した場合、当社は、取引の種類や本商品の購入数等に応じて当社が定める報酬基準に従い成果報酬をアンバサダーに対して支払います。なお、成果報酬の基準は、本プログラムサイト上への掲示又はアンバサダーに対して個別に通知されます。
            </li>
            <li>
              本報酬は、キャンペーン、対象となる商品その他の事由により報酬基準が追加・変更されることがあります。これら特別の報酬の基準は、本プログラムサイト上への掲示又はアンバサダーに対して個別に通知されます。
            </li>
            <li>
              前2項の定めにかかわらず、次の各号のいずれかに該当する場合は、本報酬の支払対象にならないものとします。
            </li>
            <ol>
              <li>ユーザが本商品の新規ユーザでなかった場合</li>
              <li>
                第1項で本商品を購入したユーザが、アンバサダーと同一住所の者である場合
              </li>
              <li>
                ユーザが本商品の既存ユーザ（過去にユーザであった者を含む）と同一住所の者である場合
              </li>
              <li>
                ユーザが、アンバサダーの専用ページを経由して本商品を購入したことを当社において確認できなかった場合
              </li>
              <li>
                返品（受取拒否、長期不在持ち戻りを含みます。）、注文のキャンセル等が行われ、当社から当該ユーザに対して本商品の代金が返金された場合
              </li>
              <li>
                その他、本規約への違反行為、不正な報酬獲得行為又はユーザと当社との間の取引が正常に完了しなかった場合
              </li>
            </ol>
            <li>
              第1項及び第2項の定めにかかわらず、次の各号のいずれかに該当する場合は、その原因となる事由が解消されるまでの間、本報酬の支払いを一時停止するものとします。
            </li>
            <ol>
              <li>
                アンバサダーが登録した指定口座に入力ミス、口座凍結、口座解約等の事由により正常に振り込みができない場合
              </li>
              <li>
                その他、アンバサダーの責めに帰すべき事由によりアンバサダーが本報酬を受領できなかった場合
              </li>
            </ol>
            <li>
              当社は、アンバサダーに対して、本報酬の対象となった本商品の販売数量を除き、アンバサダーから紹介を受けたユーザと当社間の取引状況について通知・連絡しないものとします。また、これらに関する問い合わせにも一切応じないものとします。
            </li>
          </ol>
          <li>第7条（本報酬の支払い）</li>
          <span>
            本報酬は、毎月末締めで本報酬額を算定し、翌月末日に指定口座へ振り込む方法でアンバサダーに支払うものとします。ただし、報酬支払日が土曜日、日曜日、祝日その他の金融機関休業日にあたる場合、その前営業日までに支払うものとします。なお、振込手数料は当社の負担とします。
          </span>
          <li>第8条（アンバサダーのアカウント登録の取消・利用停止・削除等）</li>
          <ol>
            <li>
              アンバサダーが以下の各号のいずれかに該当する場合、当社は、事前の通知なくアンバサダー登録の取消、本プログラムの全部若しくは一部の利用停止、又はアンバサダーに関連するコンテンツや情報の全部若しくは一部の削除の措置をとることができるものとします。なお、この場合、以後のアンバサダーへの本報酬の発生を停止するものとします。
            </li>
            <ol>
              <li>
                過去1年間において本報酬の対象となるユーザ数の合計が0名の場合
              </li>
              <li>法令に違反した場合</li>
              <li>本規約に違反し、又は不正行為があった場合</li>
              <li>登録した情報が虚偽の情報であると当社が判断した場合</li>
              <li>本規約上必要となる手続又は当社への連絡を行わなかった場合</li>
              <li>登録した連絡先が不通になったことが判明した場合</li>
              <li>
                他のアンバサダー、ユーザ又は第三者に不当に迷惑をかけた場合
              </li>
              <li>第三者になりすます行為を行った場合</li>
              <li>
                登録した金融機関の口座に関し違法又は不適切その他の問題があることが当該金融機関による指摘その他により判明した場合
              </li>
              <li>第3条第4項各号のいずれかに該当する場合</li>
              <li>その他当社が登録を適当でないと判断した場合</li>
            </ol>
            <li>
              当社は、前項の措置を取った場合であっても、アンバサダーに対し、その理由を説明する義務を負わないものとします。なお、当社は、アンバサダーが前項各号のいずれにも該当しないことを確認するために、当社が必要と判断する本人確認を行うことができ、確認が完了するまで本プログラムの全部若しくは一部の利用停止等の措置をとることができます。
            </li>
            <li>
              当社は、本条の措置により生じる損害について、一切の責任を負わないものとします。
            </li>
          </ol>
          <li>第9条（損害賠償等）</li>
          <ol>
            <li>
              アンバサダーによる本プログラムの不正、不当若しくは違法な利用又は利用規約違反によってユーザ、他のアンバサダー又は第三者との間でクレーム、紛争等が生じた場合、アンバサダーは、すべて自己の責任と負担において解決するものとし、当社にはいかなる迷惑もかけないものとします。なお、この場合において、当社がユーザ、他のアンバサダー又は第三者に賠償を行ったときは、アンバサダーに対して求償を行うことができるものとします。
            </li>
            <li>
              アンバサダーによる本プログラムの不正、不当若しくは違法な利用又は利用規約違反によって当社に損害を生じさせた場合、アンバサダーは、その損害を賠償する義務を負うとともに、その解決のために要した弁護士費用その他一切の諸経費を当社に支払うものとします。
            </li>
            <li>
              当社は、アンバサダーとユーザ、他のアンバサダー又は第三者との間の紛争について、アンバサダーの同意を得ることなく、当該ユーザ、他のアンバサダー又は第三者に対して、当該紛争に関連する情報の提供その他の援助を行うことができるものとします。
            </li>
          </ol>
          <li>第10条（権利の非許諾）</li>
          <span>
            当社は、本規約で明文をもって許諾された以外の権利をアンバサダーに対し付与するものではありません。また、アンバサダーは、許諾された以外の当社の商号、商標、標章等の利用を行うことはできません。
          </span>
          <li>第11条（税金及び費用）</li>
          <ol>
            <li>
              アフィリエイト媒体並びにリンク等の設置、運営及び管理、あるいは成果報酬の支払にともない税金や付帯費用が発生する場合には、アンバサダーがこれらを負担するものとします。
            </li>
            <li>
              アンバサダーは、報酬額の算出及び報酬の支払いのために当社が指示する税務上、行政上の手続を行うものとし、当社がそれに関連する資料の提出及び情報の開示を求めた場合にはそれに従わなければなりません。
            </li>
          </ol>
          <li>第12条（秘密保持）</li>
          <span>
            アンバサダーは、本契約期間中又は本契約終了後にかかわらず、本契約及び本契約に関連して知り得た情報（IPアドレスその他ユーザ又は他のアンバサダーの特定につながる情報、リンク等の設置又は成果報酬の支払のために当社から開示された情報、本プログラムの利用に際して知り得た本プログラム・当社・ユーザ・他のアンバサダーに関する情報等を含みますがこれらに限られません。）を他に開示・漏洩してはならず、本プログラムの利用以外の目的で使用してはならないものとします。
          </span>
          <li>第13条（退会）</li>
          <span>
            アンバサダーは、当社所定の方法で当社に通知することにより、本プログラムから退会することができます。
          </span>
          <li>第14条（本プログラム内容等の変更・中断・停止）</li>
          <ol>
            <li>
              当社は、アンバサダーへ事前に告知又は通知することなく本プログラムの内容・名称を変更することができるものとします。
            </li>
            <li>
              当社は、アンバサダーへ事前に告知又は通知することなく本プログラムを一時的に中断・停止することができるものとします。
            </li>
            <li>
              当社は、前2項により生じた利用者の損害について、理由の如何を問わず、一切の責任を負わないものとします。
            </li>
          </ol>
          <li>第15条（本プログラムの終了）</li>
          <ol>
            <li>
              当社は、アンバサダーへ事前に告知又は通知の上、本プログラムを終了することができるものとします。
            </li>
            <li>
              本プログラム終了後にアンバサダーが本報酬の付与条件を充たした場合、本報酬を受けることはできません。
            </li>
            <li>
              当社は、前項により生じた利用者の損害について、理由の如何を問わず、一切の責任を負わないものとします。
            </li>
          </ol>
          <li>第16条（システムの変更・停止）</li>
          <ol>
            <li>
              当社は、利用者に事前に告知又は通知することなく、本プログラムサイトのユーザーインターフェイス又はシステムを変更できるものとします。
            </li>
            <li>
              当社は、保守作業・システム復旧による場合又は停電・火災等の不可抗力その他やむをえない理由により本プログラムを中止又は中断することがあります。この場合、あらかじめその旨を告知するものとします。ただし、緊急の場合は、この限りではありません。
            </li>
          </ol>
          <li>第17条（免責）</li>
          <ol>
            <li>
              当社は、本プログラムの内容・品質・水準、安定的な提供、本プログラムの利用に伴う結果等については、いかなる保証も行わないものとします。
            </li>
            <li>
              本プログラムへのアクセス不能、利用者のコンピュータにおける障害・エラー・バグ等の発生及び本プログラムに関連するコンピュータ・システム・通信回線等の障害に関して、当社は、一切責任を負わないものとします。
            </li>
            <li>
              当社は、利用者設備等の不具合及び障害等に起因する通信不良・遅延・データの誤送等による損害について、一切の責任を負わないものとします。
            </li>
          </ol>
          <li>第18条（本規約の変更）</li>
          <ol>
            <li>
              当社は、本規約について、アンバサダーの一般の利益に適合するとき、又は本規約の変更が本サービスの目的に反せず、かつ、変更の必要性・変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるときは、アンバサダーの承諾なく本規約等を変更できるものとします。この場合、アンバサダーは改定後の規約に従うものとします。
            </li>
            <li>
              当社は、前項の改定を行うときは、予め変更の効力発生日を定めた上で、変更内容及び効力発生日を第4条に定める方法で周知するものとします。
            </li>
            <li>
              本規約の変更の効力発生は、前項において事前に定めた効力発生日に生じるものとします。
            </li>
          </ol>
          <li>第19条（本契約の終了等）</li>
          <ol>
            <li>
              アンバサダーが退会、登録の抹消、本プログラムの終了等によりアンバサダーとしての資格を喪失したときは、本契約はアンバサダーとしての資格を喪失したときをもって終了するものとします。ただし、第9条、第10条から第12条、第15条、第20条、第22条、第23条については終了後も効力を有するものとします。
            </li>
            <li>
              本契約が終了した場合、アンバサダーはアフィリエイト媒体からリンク等を直ちに削除するものとします。
            </li>
          </ol>
          <li> 第20条（個人情報の取り扱い）</li>
          <span>
            当社は、本プログラムの利用によって取得する個人情報について、当社が別途定めるプライバシーポリシー（https://nosh.jp/policy）及び法令の規定に従い、適切に取り扱うものとします。
          </span>
          <li>第21条（Cookie(クッキー)の使用）</li>
          <ol>
            <li>
              本プログラムサイトは、アンバサダーにとって便利な機能を提供し、より使いやすい環境を実現することを目的に、Cookieという技術を利用しています。
            </li>
            <li>
              Cookieは、アンバサダーの端末を識別又はアクセスを認識する技術であり、アンバサダーの個人情報を取得するために利用するものではありません。また、携帯端末による本プログラムサイトも端末識別情報を同目的で利用する場合がございます。なお、Cookieについては、アンバサダーが希望される場合、アンバサダーご自身でブラウザのCookie機能を無効にすることができますが、本プログラムサイトの一部が正常に機能しない可能性があります。
            </li>
            <li>
              アンバサダーは、当社がCookieにより利用状況を記録することに同意するものとします。
            </li>
          </ol>
          <li>第22条（権利義務の譲渡の禁止）</li>
          <span>
            アンバサダーは、利用契約上の地位又は本規約に基づく権利若しくは義務を第三者に譲渡し、又は担保に供することはできません。
          </span>
          <li>第23条 (準拠法及び管轄裁判所)</li>
          <span>
            本利用規約に関する準拠法は日本法とし、本利用規約に関連して当社とアンバサダーの間で紛争が生じた場合は、訴額に応じて、大阪地方裁判所又は大阪簡易裁判所を第1審の専属的合意管轄裁判所とします。
          </span>
          <div className={module.primary}>
            <span>附則</span>
            <br />
            <span>2023年10月19日施行</span>
            <br />
            <span>ナッシュ株式会社</span>
          </div>
        </ul>
      </Box>
      <Box sx={{ textAlign: "center", marginTop: "32px" }}>
        <FormControlLabel
          label="利用規約に同意する"
          id="mcta_amb_agr"
          sx={{
            color: "#15B855",
          }}
          control={
            <Checkbox
              sx={{
                position: "relative",
                bottom: "1px",
              }}
              checked={isRead}
              onChange={handleChange}
            />
          }
        />
      </Box>
    </div>
  );
};

export default Teams;
